/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */
import { closeModalAction } from "../../Redux/actions/modal";
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AiFillFilePdf } from 'react-icons/ai';
import { GrFormClose } from 'react-icons/gr';

const InboxModal = () => {
  const dispatch = useDispatch();
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [selectedReason, setSelectedReason] = useState('');

  const closeInboxModalHandler = () => {
    dispatch(closeModalAction());
  };

  const rejectOfferHandler = () => {
    setShowRejectPopup(true);
  };

  const submitHandler = () => {
    if (!selectedReason) {
      alert('Please select a reason before submitting.');
      return;
    }

    console.log('Selected Reason:', selectedReason);
    setShowRejectPopup(false);
  };

  return (
    <>
      <div className="fixed top-0 left-0 w-screen h-screen opacity-100 overflow-y-scroll bg-white z-30">
        <div className="relative w-[90%] mx-auto shadow-2xl py-12 my-12 rounded-lg">
          <div className="w-[150px] h-[150px] mx-auto">
            <AiFillFilePdf className="w-full h-full text-[#B30B00]" />
          </div>
          <p className="cursor-pointer text-center font-semibold">
            Download file
          </p>

          <div className="flex justify-center gap-6 items-center mx-4 my-8">
            <div className="w-[150px] p-2 text-white text-center font-semibold rounded-lg cursor-pointer bg-green-600 hover:bg-green-800">
              Accept
            </div>

            <div
              className="w-[150px] p-2 text-white text-center font-semibold rounded-lg cursor-pointer bg-red-500 hover:bg-red-800"
              onClick={rejectOfferHandler}
            >
              Reject
            </div>
          </div>
          <div
            className="absolute w-[30px] flex justify-center border-2 top-4 right-6 text-black hover:bg-[grey] cursor-pointer"
            onClick={closeInboxModalHandler}
          >
            <GrFormClose className="text-2xl" />
          </div>
        </div>
      </div>

      {showRejectPopup && (
        <div className="fixed top-0 left-0 w-screen h-screen opacity-100 overflow-y-scroll bg-white bg-opacity-100 z-40">
          <div className="relative w-80 md:w-80  mx-auto shadow-2xl py-8 px-6 bg-white rounded-lg">
            <h2 className="text-center text-xl text-navBg font-semibold mb-4">
             We would like to know why you rejected our offer 
            </h2>
            <div className="mb-4">
              <label className="flex justify-between font-semibold items-center mb-4">
                You're not impressed by the offer
                <input
                  type="radio"
                  name="reason"
                  value="not impressed by the offer"
                  checked={selectedReason === 'not impressed by the offer'}
                  onChange={(e) => setSelectedReason(e.target.value)}
                />
              </label>
              <label className="flex justify-between font-semibold items-center mb-4">
                You're not ready for the project
                <input
                  type="radio"
                  name="reason"
                  value="not ready for the project"
                  checked={selectedReason === 'not ready for the project'}
                  onChange={(e) => setSelectedReason(e.target.value)}
                />
              </label>
              <label className="flex justify-between font-semibold items-center mb-4">
                You want to counter the offer
                <input
                  type="radio"
                  name="reason"
                  value="want to counter the offer"
                  checked={selectedReason === 'want to counter the offer'}
                  onChange={(e) => setSelectedReason(e.target.value)}
                />
              </label>
            </div>
            <div className="flex mt-8 justify-center ">
              <button
                className="w-[130px] p-3 text-white text-sm text-center font-semibold rounded-lg cursor-pointer bg-navBg hover:bg-blue-700"
                onClick={submitHandler}
              >
                Submit
              </button>
            </div>
            <div
              className="absolute w-[30px] flex justify-center border-2 top-4 right-2 text-black hover:bg-[grey] cursor-pointer"
              onClick={() => setShowRejectPopup(false)}
            >
              <GrFormClose className="text-xl" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InboxModal;